<template>
  <div class="p-3 flex flex-col bg-key rounded-4xl">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-1 h-9 text-black-white text-l-medium">
        <Icon icon="Technology-Wireframe-SpatialAudio" class="size-6" />
        <span class="text-l-medium text-black-white">{{
          t('setting.device.frequencyBand.title')
        }}</span>
      </div>
    </div>
    <div>
      <span class="text-text-body-default text-m-medium">{{
        t('setting.device.frequencyBand.description')
      }}</span>
    </div>

    <div class="pt-3 pb-1.5 flex-1 flex flex-col gap-2">
      <div class="flex w-full rounded-full overflow-hidden gap-0.5 bg-neutral-light-default1">
        <div
          v-for="item in frequencyBandOptions"
          :key="item.value"
          class="flex-1 h-3 transition-colors duration-300 ease-in-out cursor-pointer rounded-full"
          :style="{
            background: frequencyBand === item.value ? 'var(--color-brand-blue1)' : '',
          }"
          @click="setFrequencyBand(item.value)"
        />
      </div>
      <div class="flex w-full">
        <div
          v-for="item in frequencyBandOptions"
          :key="item.value"
          class="flex-1 flex justify-center"
        >
          <button
            class="w-full cursor-pointer"
            :class="
              frequencyBand === item.value
                ? 'text-l-bold text-brand-blue1'
                : 'text-m-medium text-text-body-default'
            "
            @click="setFrequencyBand(item.value)"
          >
            {{ item.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, onMounted, ref } from 'vue'
  import { Icon } from '@rapoo/element'
  import { useDeviceStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  const frequencyBand = ref(0)

  const frequencyBandOptions = [
    { label: '1', value: 0 },
    { label: '2', value: 1 },
    { label: '3', value: 2 },
    { label: '4', value: 3 },
    { label: '5', value: 4 },
    { label: '6', value: 5 },
    { label: '7', value: 6 },
    { label: '8', value: 7 },
  ]

  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)
  const baseSettings = computed(() => {
    if (!currentDevice.value?.features) return null
    return currentDevice.value.features.baseSettings
  })

  const initFrequencyBand = () => {
    if (!baseSettings.value) return
    baseSettings.value.getChannelIndex().then((band) => {
      frequencyBand.value = band
    })
  }
  onMounted(() => {
    initFrequencyBand()
  })

  const setFrequencyBand = (band: number) => {
    if (!baseSettings.value) return
    baseSettings.value.setChannelIndex(band).then(() => {
      frequencyBand.value = band
    })
  }
</script>
